(()=>{
  const initialiseFinder=root=>{
    if(root.dataset.cmReady)return;
    root.dataset.cmReady='true';
    const filters=[...root.querySelectorAll('[data-cm-filter]')];
    const projects=[...root.querySelectorAll('[data-cm-project]')];
    const status=root.querySelector('[data-cm-count]');
    const update=()=>{
      const values=Object.fromEntries(filters.map(input=>[input.dataset.cmFilter,input.value]));
      let count=0;
      projects.forEach(project=>{
        const matches=['craft','skill','time'].every(key=>values[key]==='all'||values[key]===project.dataset[key])&&(values.budget==='all'||Number(project.dataset.price)<=Number(values.budget));
        project.hidden=!matches;
        if(matches)count++;
      });
      status.textContent=status.dataset.countTemplate.replace('__COUNT__',String(count));
      root.querySelector('[data-cm-empty]').hidden=count!==0;
    };
    filters.forEach(input=>input.addEventListener('change',update));
    root.querySelectorAll('[data-cm-reset]').forEach(button=>button.addEventListener('click',()=>{filters.forEach(input=>input.value='all');update();}));
    root.querySelector('[data-cm-filters]').hidden=false;
    status.hidden=false;
    update();
  };
  const popupOpeners=new WeakMap();
  const popupCleanups=new WeakMap();
  const seenOffers=new Set();
  const offerKey=root=>'cm-welcome-offer:'+(root.dataset.cmPreviewMode==='true'?'preview':'live');
  const hasSeen=key=>{
    if(seenOffers.has(key))return true;
    try{return window.sessionStorage.getItem(key)==='seen';}catch{return false;}
  };
  const remember=key=>{
    seenOffers.add(key);
    try{window.sessionStorage.setItem(key,'seen');}catch{/* The in-memory flag still prevents repeats on this page. */}
  };
  const subscriberKey='cm-email-subscriber';
  let subscriberConfirmed=false;
  const isSubscriber=()=>{
    if(subscriberConfirmed||document.body.dataset.cmEmailSubscriber==='true')return true;
    try{return window.localStorage.getItem(subscriberKey)==='true';}catch{return false;}
  };
  const hideSignupPrompts=()=>{
    if(!isSubscriber()||window.Shopify?.designMode)return;
    document.querySelectorAll('[data-cm-welcome]').forEach(root=>{
      const success=root.querySelector('[data-cm-signup-feedback="success"]');
      if(!success){
        popupCleanups.get(root)?.();
        root.hidden=true;
        root.style.display='none';
      }else{
        root.querySelectorAll('input,form button,[data-cm-offer-launcher]').forEach(node=>node.hidden=true);
      }
    });
    document.querySelectorAll('.cm-newsletter').forEach(root=>{
      const success=root.querySelector('[role="status"]');
      if(success){root.querySelector('.cm-newsletter__form')?.setAttribute('hidden','');}
      else{root.hidden=true;root.style.display='none';}
    });
    document.querySelectorAll('a[href]').forEach(link=>{
      const url=new URL(link.href,window.location.href);
      if(url.origin===window.location.origin&&url.hash==='#join-craft-club'){
        const announcement=link.closest('.cm-announcement');
        (announcement||link).hidden=true;
        (announcement||link).style.display='none';
      }
    });
  };
  const confirmSubscriber=()=>{
    subscriberConfirmed=true;
    try{window.localStorage.setItem(subscriberKey,'true');}catch{}
    hideSignupPrompts();
  };
  const initialiseSignup=root=>{
    if(root.dataset.cmReady)return;
    root.dataset.cmReady='true';
    root.querySelector('[data-cm-preview-submit]').addEventListener('click',()=>{
      const email=root.querySelector('[data-cm-preview-email]');
      const consent=root.querySelector('[data-cm-preview-consent]');
      if(!email.reportValidity()||!consent.reportValidity())return;
      const status=root.querySelector('[data-cm-preview-status]');
      status.hidden=false;
      status.focus({preventScroll:true});
      root.dispatchEvent(new CustomEvent('cm:welcome-preview-complete',{bubbles:true}));
    });
    root.querySelector('[data-cm-preview-email]').addEventListener('keydown',event=>{
      if(event.key!=='Enter')return;
      event.preventDefault();
      root.querySelector('[data-cm-preview-submit]').click();
    });
  };
  const initialisePopup=root=>{
    if(isSubscriber()&&!window.Shopify?.designMode){hideSignupPrompts();return;}
    if(popupOpeners.has(root))return;
    const dialog=root.querySelector('[data-cm-welcome-dialog]');
    const card=root.querySelector('[data-cm-offer-form-card]');
    const launcher=root.querySelector('[data-cm-offer-launcher]');
    if(!dialog||typeof dialog.showModal!=='function'||!card||!launcher)return;
    const key=offerKey(root);
    const feedback=root.querySelector('[data-cm-signup-feedback]');
    if(feedback){
      if(feedback.dataset.cmSignupFeedback==='success'){remember(key);confirmSubscriber();}
      return;
    }
    let previousFocus=null;
    let automaticTimer=null;
    const stopAutomatic=()=>{
      if(automaticTimer!==null)window.clearTimeout(automaticTimer);
      automaticTimer=null;
      window.removeEventListener('scroll',queueAutomatic);
    };
    const open=trigger=>{
      if(isSubscriber()&&!window.Shopify?.designMode)return false;
      if(dialog.open)return true;
      if(!dialog.isConnected||document.querySelector('dialog[open]'))return false;
      previousFocus=trigger||document.activeElement;
      dialog.showModal();
      document.documentElement.classList.add('cm-popup-open');
      remember(key);
      stopAutomatic();
      return true;
    };
    const queueAutomatic=()=>{
      if(hasSeen(key)){stopAutomatic();return;}
      if(window.scrollY<120||automaticTimer!==null)return;
      const delay=Math.max(0,Math.min(15,Number(root.dataset.cmPopupDelay)||0));
      automaticTimer=window.setTimeout(()=>{
        automaticTimer=null;
        const editing=document.activeElement?.matches('input,textarea,select,[contenteditable="true"]');
        const anotherOverlay=document.querySelector('dialog[open],cart-drawer.active,details-modal details[open],.menu-drawer-container[open],quick-add-modal[open],.cm-nav__shop[open],.cm-mobile-menu[open]');
        if(!document.hidden&&!editing&&!anotherOverlay)open();
      },delay*1000);
    };
    dialog.querySelector('[data-cm-dialog-content]').append(card);
    dialog.hidden=false;
    launcher.hidden=false;
    dialog.querySelectorAll('[data-cm-close-welcome]').forEach(button=>button.addEventListener('click',()=>dialog.close()));
    dialog.addEventListener('close',()=>{
      document.documentElement.classList.remove('cm-popup-open');
      if(previousFocus?.isConnected&&typeof previousFocus.focus==='function')previousFocus.focus({preventScroll:true});
      previousFocus=null;
    });
    root.addEventListener('cm:welcome-preview-complete',()=>{
      remember(key);
      const dismiss=dialog.querySelector('[data-cm-popup-dismiss]');
      dismiss.textContent=dismiss.dataset.continueLabel;
    });
    card.querySelector('form')?.addEventListener('submit',event=>{
      if(event.currentTarget.checkValidity())remember(key);
    });
    popupOpeners.set(root,open);
    popupCleanups.set(root,()=>{
      stopAutomatic();
      if(dialog.open)dialog.close();
      document.documentElement.classList.remove('cm-popup-open');
      popupOpeners.delete(root);
      popupCleanups.delete(root);
    });
    if(root.dataset.cmPopupAuto==='true'&&root.dataset.cmPopupEligible==='true'&&!hasSeen(key)){
      window.addEventListener('scroll',queueAutomatic,{passive:true});
      queueAutomatic();
    }
  };
  document.addEventListener('click',event=>{
    const trigger=event.target.closest('a[href],button[data-cm-open-welcome]');
    if(!trigger)return;
    let root;
    if(trigger.matches('[data-cm-open-welcome]')){
      root=trigger.closest('[data-cm-welcome]');
    }else{
      const url=new URL(trigger.href,window.location.href);
      if(url.origin!==window.location.origin||url.hash!=='#join-craft-club')return;
      root=document.querySelector('[data-cm-welcome]');
    }
    const open=popupOpeners.get(root);
    if(open?.(trigger))event.preventDefault();
  });
  document.addEventListener('shopify:section:unload',event=>{
    event.target.querySelectorAll('[data-cm-welcome]').forEach(root=>popupCleanups.get(root)?.());
  });
  const initialise=scope=>{
    if(scope.querySelector('[data-cm-signup-feedback="success"]')||scope.querySelector('.cm-newsletter [role="status"]'))confirmSubscriber();
    scope.querySelectorAll('[data-cm-finder]').forEach(initialiseFinder);
    scope.querySelectorAll('[data-cm-preview-signup]').forEach(initialiseSignup);
    scope.querySelectorAll('[data-cm-welcome]').forEach(initialisePopup);
    hideSignupPrompts();
  };
  window.addEventListener('storage',event=>{if(event.key===subscriberKey)hideSignupPrompts();});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initialise(document));else initialise(document);
  document.addEventListener('shopify:section:load',event=>initialise(event.target));
})();

